/** Shared launch-wipe timing — keep in sync with IntroCovers / chapter CSS. */
export const INTRO_WIPE_MS = 1200;

/**
 * Narrow / phone clip wipes. Shorter than desktop so `clip-path` spends less
 * time on the compositor (the main source of phone jank).
 */
export const INTRO_WIPE_MS_NARROW = 750;

/** CSS custom property set on hub `main` — duration for wipe + lead edges. */
export const HUB_WIPE_MS_VAR = "var(--hub-wipe-ms)";

/**
 * Chapter mosaic / snap pane height. Locked to `svh` so URL-bar show/hide
 * does not recompute chapter height. The fixed stage stays on this for every
 * stop (including credits) so Arizona isn’t resized on the credits hop.
 * Narrow ballast uses `lvh − svh` (stable), not `dvh`.
 */
export const HUB_STAGE_H_VAR = "100svh";

/**
 * Credits snap pane only — `svh` plus the large-viewport gap so document
 * scroll has room when chrome hides. Stage frame stays `HUB_STAGE_H_VAR`.
 */
export const HUB_CREDITS_H_VAR = "calc(100svh + (100lvh - 100svh))";

export function introWipeMs(narrow: boolean): number {
  return narrow ? INTRO_WIPE_MS_NARROW : INTRO_WIPE_MS;
}

/** Frames after enter `open` before latching `data-hub-fill`. */
export const HUB_ENTER_FILL_FRAMES = 4;
/** ms before wipe-end to latch `data-hub-fill-lock` (`animation: none`). */
export const HUB_ENTER_FILL_LOCK_LEAD_MS = 64;
/** ms before wipe-end to drop depart paint / pin closed. */
export const HUB_DEPART_GONE_LEAD_MS = 48;
